import React from "react";
import {
    Card,
    CardHeader,
    CardContent,
    Grid,
    Typography
} from "@material-ui/core";

function formatPrice(value) {
    if (value == null || value === "") return "–";
    const n = Number(value);
    if (!Number.isFinite(n)) return String(value);
    return n.toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export default function KpiCard({ stats }) {
    const totalNews = stats?.totalNews ?? "–";
    const totalSignals = stats?.totalSignals ?? "–";
    const longSignals = stats?.longSignals ?? stats?.buySignals ?? "–";
    const shortSignals = stats?.shortSignals ?? stats?.sellSignals ?? "–";
    const avgPrice = stats?.avgPrice != null ? formatPrice(stats.avgPrice) : "–";
    const lastPrice = stats?.lastPrice != null ? formatPrice(stats.lastPrice) : "–";
    const companyName = stats?.companyName || "–";
    const symbol = stats?.symbol || "–";

    return (
        <Card style={{ marginBottom: 16 }}>
            <CardHeader title="KPIs" />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography variant="body2">Total News</Typography>
                        <Typography variant="h6">{totalNews}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2">Total Alerts</Typography>
                        <Typography variant="h6">{totalSignals}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2">LONG</Typography>
                        <Typography variant="h6">{longSignals}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2">SHORT</Typography>
                        <Typography variant="h6">{shortSignals}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2">Ø Preis</Typography>
                        <Typography variant="h6">{avgPrice}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2">Letzter Preis</Typography>
                        <Typography variant="h6">{lastPrice}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2">Symbol</Typography>
                        <Typography variant="h6">{symbol}</Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2">Company</Typography>
                        <Typography variant="h6">{companyName}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}